import { Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MapService } from 'src/app/services/map.service';
import { SearchPlaceComponent } from '../../shared/address/search-place/search-place.component';
import { SelectPoiComponent } from '../../shared/address/select-poi/select-poi.component';
import { icon, ico_active, ico_active_p2p } from 'src/configs/map_configuration';
import { GMapContainerComponent } from '../../shared/map/gmap-container/gmap-container.component';
import { Subscription, forkJoin } from 'rxjs';
import { MapMarker } from 'src/app/models/marker';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';
import { BaseService } from 'src/app/services/base.service';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-point-to-point',
  templateUrl: './point-to-point.component.html',
  styleUrls: ['./point-to-point.component.scss']
})
export class PointToPointComponent extends GMapContainerComponent implements OnInit, OnDestroy {

  public env = environment;
  public p2pResult: any;
  public temp_point = null;
  public pointB = null;
  public pointA = null;
  public icon_pointB = icon.POINT_B_END.null.url;
  public icon_pointA = icon.POINT_A_END.null.url;
  public coordinates_type_B = null;
  public coordinates_type_A = null;
  public showToast = false;
  public requestOfControl = new FormControl();
  public project: any;
  public showResultBtn = false;
  private companyOptions: any[];
  public filteredCompanies: Observable<string[]>;
  public errorTitle: string;
  public wait = false;
  public waitFeasibility = false;
  private ringLines: any[];
  private typesMarkersPointsB = this.typesMarkersPointsNTW.concat(['POINT_CIVIC_B', 'POINT_PLACE_B', 'POINT_PICKED_B', 'POINT_POI_B']);
  private typesMarkersPointsA = this.typesMarkersPointsNTW.concat(['POINT_CIVIC_A', 'POINT_PLACE_A', 'POINT_PICKED_A', 'POINT_POI_A']);
  private typesMarkersPointsAll = this.typesMarkersPointsA.concat(this.typesMarkersPointsB);
  private typesMarkersPoints = {
    B: this.typesMarkersPointsB,
    A: this.typesMarkersPointsA,
    ALL: this.typesMarkersPointsAll
  };
  public modalEnd: 'A' | 'B' = null;
  public showSalesforceConfirmation = false;
  public salesforcePersonalPage = '';
  public waitSalesforce = false;
  public salesforceToastrOptions = {
    enableHtml: true,
    closeButton: true,
    autoDismiss: false,
    newestOnTop: true,
    progressBar: false,
    positionClass: 'toast-bottom-center',
    preventDuplicates: false,
    disableTimeOut: true
  };
  public typeSearchPlace = {
    pointB: '',
    pointA: ''
  };
  @ViewChild('searchPoiB', { static: false }) searchPoiB: SelectPoiComponent;
  @ViewChild('searchPoiA', { static: false }) searchPoiA: SelectPoiComponent;
  @ViewChild('searchPlaceB', { static: false }) searchPlaceB: SearchPlaceComponent;
  @ViewChild('searchPlaceA', { static: false }) searchPlaceA: SearchPlaceComponent;

  constructor(public mapService: MapService,
    private baseService: BaseService, public zone: NgZone) {
    super(mapService, zone);
  }

  // Lifecycle

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.searchBuildingPlaceholdersSubscription$ instanceof Subscription) {
      this.searchBuildingPlaceholdersSubscription$.unsubscribe();
    }
    if (this.pointB) {
      // this case is only for buildings that contain the parameter labelOnInput
      if (this.pointB.labelOnInput) {
        this.pointB.icons = [
          { zoom_from: 1, zoom_to: 30, path: ico_active },
        ];
        this.pointB.type = 'POINT_CIVIC';
      }
      const marker = this.pointB;
      this.mapService.pointSaved = {
        marker: marker,
        zoom: this.map.map.getZoom()
      };
    } else {
      this.mapService.pointSaved = null;
    }
  }

  // Map events

  public onMapReady() {
    this.getCompanyList();
    this.requestOfControl.setValue('');
    this.populateMapDefault(this.map.map.getZoom());
    // If there is a point saved from Network Coverage
    if (this.mapService.pointSaved) {
      this.map.showMarkers([this.mapService.pointSaved.marker]);
      const latlng = new google.maps.LatLng(this.mapService.pointSaved.marker.coordinates.lat, this.mapService.pointSaved.marker.coordinates.lng);
      this.map.zoomToCoordinates(latlng, this.mapService.pointSaved.zoom, false);
      this.showToastAfterPoint(this.mapService.pointSaved.marker);
      this.mapService.pointSaved = null;
    }
  }

  // Select point by click on marker
  public onMarkerClicked(marker) {
    this.modalEnd = null; //set to null modalEnd to reset when I click on the map. To make the Toast open
    switch (marker.type) {
      case 'cluster': this.onSelectCluster(marker); break;
      default: this.onSelectBuilding(marker); break;
    }
  }

  // Select point by click on map
  public onPickedClicked(picked) {
    if (this.map.map.getZoom() >= 12) {
      this.geocoder.geocode({ location: picked.latLng }, (res) => {
        picked.label = this.mapService.pointLabel(res);
        this.showToastAfterPicked(picked);
      });
    }
  }

  // Company list

  private getCompanyList() {
    this.companyOptions = [];
    const test = { name: 'test' };
    this.baseService.getCompanies().subscribe(res => {
      if (res.length) {
        for (const obj of res) {
          this.companyOptions.push(this.mapService.capitalizeFirstLetter(obj));
        }
        this.companyOptions.push(this.mapService.capitalizeFirstLetter(test.name));
      }
    });
    this.filteredCompanies = this.requestOfControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(this.mapService.capitalizeFirstLetter(value)))
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (filterValue && filterValue.length > 2) {
      return this.companyOptions.filter(option => option.toLowerCase().includes(filterValue));
    }
  }

  // Always
  private onSelectBuilding(markerCivic: MapMarker, checkIfMultiple = true, end?: string) {
    this.wait = true;
    if (checkIfMultiple) {
      this.modalBuildings = [];
      if (this.getBuildingsByCoordinatesSubscription$ instanceof Subscription) {
        this.getBuildingsByCoordinatesSubscription$.unsubscribe();
      }
      this.getBuildingsByCoordinatesSubscription$ = this.mapService.getBuildingByCoordinates(markerCivic.coordinates.lat, markerCivic.coordinates.lng).subscribe(res => {
        if (res.results && res.results.length && res.results.length > 1) {
          this.modalBuildings = res.results;
          this.zone.run(() => {
            this.mapService.open('multiBuildingModal');
          });
          this.wait = false;
        } else {
          this.showToastAfterPoint(markerCivic);
          this.wait = false;
          this.mapService.close('multiBuildingModal');
        }
      });
    } else {
      if (this.modalEnd) { //check the value of modalEnd. If I find it I directly set the point on the input, else Toast
        this.setBuilding(markerCivic, this.modalEnd)
      } else {
        this.showToastAfterPoint(markerCivic);
      }
      this.wait = false;
      this.mapService.close('multiBuildingModal');
    }
  }

  public onClickBuilding(building) {
    const c = this.mapService.civic2Marker(building.selected_building);
    this.onSelectBuilding(c, false);
  }

  private setBuilding(marker: any, end: string) {
    this.temp_point = marker;
    this.temp_point.label = this.getSingleLabel(this.temp_point.label);
    this.onSelectPlaceFromToast(end);
  }

  private showToastAfterPoint(marker) {
    this.temp_point = marker;
    this.temp_point.label = this.getSingleLabel(this.temp_point.label);
    this.showToast = true;
  }

  // If picked from map
  private showToastAfterPicked(picked) {
    const marker = this.mapService.picked2Marker(picked);
    this.map.showMarkers([marker], { clearTypes: this.typesMarkersPointsNTW });
    this.temp_point = marker;
    this.showToast = true;
  }

  public closeToast() {
    this.showToast = false;
    this.temp_point = null;
    this.map.showMarkers(null, { clearTypes: ['PICKED'] });
  }

  public onSelectPlaceFromToast(end) {
    const typeEnd = '_' + end;
    let iconToUse;
    if (this.mapService.pointSaved && this.mapService.pointSaved.icon && this.mapService.pointSaved.type !== 'PICKED') {
      iconToUse = this.mapService.pointSaved.icon;
      this.mapService.pointSaved = null;
    } else {
      iconToUse = this.mapService.findIconMarkerByType(this.temp_point, end);
    }
    const markerPoint = this.mapService.marker2MarkerPoint(this.temp_point, this.temp_point.type + typeEnd);
    this.map.removeMarkersByTypes(this.typesMarkersPoints[end]);
    if (this.temp_point.type == 'POI') {
      this.onSelectedPoi(markerPoint, true, iconToUse, end);
    } else if (this.temp_point.type == 'POP') {
      this.onSelectedPop(markerPoint, iconToUse, end);
    } else if (this.temp_point.type.includes('FTTH') || this.temp_point.type.includes('MAN')) {
      this.setPoint(markerPoint, end, false, 'BUILDING', iconToUse);
    } else {
      this.setPoint(markerPoint, end, false, 'POINT', iconToUse);
    }
    this.closeToast();
  }

  // Click on map
  private setPoint(marker, end, checkBuildings, typeForBe?, iconToUse?) {
    if (end === 'B') {
      this.setPointB(marker, checkBuildings, typeForBe, iconToUse);
    } else if (end === 'A') {
      this.setPointA(marker, checkBuildings, typeForBe, iconToUse);
    }
    if (this.pointB && this.pointA) {
      this.map.fitMapFromMarkers([this.pointB, this.pointA]);
    }
  }

  private setPointB(marker, checkBuildings, typeForBe?, iconToUse?) {
    marker.type = 'POINT_PICKED_B';
    marker.typeForBe = typeForBe;

    this.pointB = marker;
    this.searchPoiB.reset();
    this.searchPlaceB.address = marker.labelOnInput ? marker.labelOnInput : marker.label;
    if (!typeForBe || (typeForBe && typeForBe !== 'GEOGRAPHIC COORDINATES')) {
      this.searchPlaceB.showCoordinatesSwitch = false;
    }
    if (iconToUse) {
      marker.icons[0].path = iconToUse;
    }
    if (typeForBe === 'POINT') {
      marker.coordinates_type = this.coordinates_type_B;
    }
    this.map.showMarkers([marker], { clearTypes: ['PICKED', 'POINT_PICKED_B', 'POINT_CIVIC_B', 'POINT_PLACE_B'] });
    let latlng;
    if (marker.coordinates && marker.coordinates.lat && marker.coordinates.lng) {
      latlng = new google.maps.LatLng(marker.coordinates.lat, marker.coordinates.lng);
    } else {
      this.wait = false;
      const content = 'The searched address is not in a valid format. Please select a suggested one.';
      this.baseService.showErrorMsg(content);
    }
    this.map.centerMapToCoordinates(latlng);
    this.icon_pointB = marker.icons[0].path.url;
    if (checkBuildings) {
      this.checkPlaceCoordinates(marker.coordinates.lat, marker.coordinates.lng, marker, 'B')
    } else {
      this.wait = false;
    }
  }

  private checkPlaceCoordinates(lat, lng, place, end) {
    let markerCivic = null;
    const placeLat = String(lat)
    const placeLng = String(lng)
    if (this.getBuildingsByCoordinatesSubscription$ instanceof Subscription) {
      this.getBuildingsByCoordinatesSubscription$.unsubscribe();
    }
    this.getBuildingsByCoordinatesSubscription$ = this.mapService.getBuildingByCoordinates(placeLat, placeLng).subscribe(res => {
      if (res && res.results) {
        const buildings = res.results;
        if (buildings && buildings.length === 1) { // if only 1 label, select the building
          markerCivic = this.mapService.civic2Marker(buildings[0]);
        } else if (buildings && buildings.length > 1) { // if more than 1 label, choose between buildings
          const searchedCivic = place.street_number ? place.street_number : this.mapService.pointInfo([place]).street_number;
          const found = buildings.filter(b => b.indirizzo && b.indirizzo.civico === searchedCivic);
          if (searchedCivic && found && found.length && found.length > 1) {
            let foundToUse;
            const foundFtth = found.filter(e => e.tipologia_building === 'FTTH')[0];
            const foundMan = found.filter(e => e.tipologia_building === 'MAN')[0];
            foundToUse = foundFtth ? foundFtth : foundMan;
            markerCivic = foundToUse ? this.mapService.civic2Marker(foundToUse) : null;
          } else if (searchedCivic && found && found.length && found.length === 1) {
            markerCivic = found && found[0] ? this.mapService.civic2Marker(found[0]) : null;
          } else {
            this.modalBuildings = buildings;
            this.zone.run(() => {
              this.mapService.open('multiBuildingModal');
            });
          }
        }
        if (markerCivic) {
          const markerPoint = this.mapService.marker2MarkerPoint(markerCivic, 'POINT_CIVIC_' + end);
          this.map.showMarkers([markerPoint], { clearTypes: this.typesMarkersPoints[end] });
          if (end == 'B') {
            this.pointB = markerCivic;
          }
          this.wait = false;
        }
        const markers = [];
        for (const civic of this.newCivics) {
          if (!markerCivic || markerCivic.id !== civic.id) {
            markers.push(this.mapService.civic2Marker(civic));
          }
        }
        this.wait = false;
      }
      this.wait = false;
    });
  }

  private setPointA(marker, checkBuildings, typeForBe?, iconToUse?) {
    marker.type = 'POINT_PICKED_A';
    marker.typeForBe = typeForBe;
    this.pointA = marker;
    this.searchPoiA.reset();
    this.searchPlaceA.address = marker.labelOnInput ? marker.labelOnInput : marker.label;
    if (!typeForBe || (typeForBe && typeForBe !== 'GEOGRAPHIC COORDINATES')) {
      this.searchPlaceA.showCoordinatesSwitch = false;
    }
    if (iconToUse) {
      marker.icons[0].path = iconToUse;
    }
    if (typeForBe === 'POINT') {
      marker.coordinates_type = this.coordinates_type_A;
    }
    this.map.showMarkers([marker], { clearTypes: ['PICKED', 'POINT_PICKED_A', 'POINT_CIVIC_A', 'POINT_PLACE_A'] });
    const latlng = new google.maps.LatLng(marker.coordinates.lat, marker.coordinates.lng);
    this.map.centerMapToCoordinates(latlng);
    this.icon_pointA = marker.icons[0].path.url;
    if (checkBuildings) {
      this.checkPlaceCoordinates(marker.coordinates.lat, marker.coordinates.lng, marker, 'A')
    } else {
      this.wait = false;
    }
  }

  // Search address
  public onSelectedPlace(place, end) {
    this.modalEnd = end;
    this.wait = true;
    if (place.geometry && place.geometry.location) {
      this.map.zoomToCoordinates(place.geometry.location, null, true);
    }
    this.place = place;
    this.isPlaceSelected = true;
    const markerPlace = this.mapService.place2Marker(place, 'POINT_PLACE_' + end);
    this.map.showMarkers([markerPlace], { clearTypes: this.typesMarkersPoints[end] });
    this.setPoint(markerPlace, end, true, 'POINT');
  }

  private onSelectedPop(markerPop: MapMarker, iconToUse, end) {
    this.geocoder.geocode({ location: markerPop.coordinates, 'region': 'it' }, (results) => {
      const p1 = this.mapService.pointInfo(results);
      markerPop.comune = p1.comune;
      markerPop.provincia = p1.provincia;
      markerPop.cap = p1.cap;
      markerPop.country = p1.country;
      markerPop.street_number = p1.street_number;
      markerPop.street = p1.street;
      if (p1) {
        this.setPoint(markerPop, end, false, 'POP', iconToUse);
      }
    });
  }


  public onSelectedPoi(poi, poiIsAMarker, iconToUse, end) {
    let markerPoi = poi;
    if (!poiIsAMarker) {
      markerPoi = this.mapService.poiToMarker(poi);
    }
    if (!iconToUse) {
      iconToUse = this.mapService.findIconMarkerByType(markerPoi, end);
    }
    this.setPoint(markerPoi, end, false, 'POI', iconToUse);
    switch (end) {
      case 'B':
        this.searchPlaceB.reset();
        this.searchPoiB.checkPoiSelected(this.pointB.label);
        this.map.zoomToCoordinates(markerPoi.coordinates, null, false);
        break;
      case 'A':
        this.searchPlaceA.reset();
        this.searchPoiA.checkPoiSelected(this.pointA.label);
        this.map.zoomToCoordinates(markerPoi.coordinates, null, false);
        break;
    }
    if (this.pointB && this.pointA) {
      this.map.fitMapFromMarkers([this.pointB, this.pointA]);
    }
  }

  public onSelectedCoordinates(place, end) {
    this.modalEnd = end;
    this.wait = true;
    this.mapService.open('loaderModal');
    if (!place || !place.coordinates) {
      this.wait = false;
      const content = 'The searched address is not in a valid format. Please select a suggested one.';
      this.mapService.handleError(null, content);
      return;
    }
    if (place) {
      this.place = place;
      this.isPlaceSelected = true;
      const p: any = place;
      this.geocoder.geocode({ location: place.coordinates, 'region': 'it' }, (results) => {
        const p1 = this.mapService.pointInfo(results);
        p.comune = p1.comune;
        p.provincia = p1.provincia;
        p.cap = p1.cap;
        p.country = p1.country;
        p.street_number = p1.street_number;
        p.street = p1.street;
        p.label = p.formatted_address;
        if (p1) {
          this.map.zoomToCoordinates(place.coordinates, null, false);
          const markerPlace = this.mapService.coordinates2Marker(place, 'POINT_PLACE_' + end);
          if (end === 'A') {
            this.setPointA(markerPlace, true, 'GEOGRAPHIC COORDINATES', ico_active_p2p)
          }
          if (end === 'B') {
            this.setPointB(markerPlace, true, 'GEOGRAPHIC COORDINATES', ico_active)
          }
        }
      });
    }
  }

  public onChangeCoordinatesFormat(e, end) {
    if (end === 'B') {
      if (e.type === 'ed50') {
        this.coordinates_type_B = 'ED50';
      } else {
        this.coordinates_type_B = null;
      }
    } else if (end === 'A') {
      if (e.type === 'ed50') {
        this.coordinates_type_A = 'ED50';
      } else {
        this.coordinates_type_A = null;
      }
    }
  }

  // other functions
  public onDismissModalMultiBuilding(event) {
    if (event) {
      if (event === 'B') {
        this.pointB = null;
        this.icon_pointB = icon.POINT_B_END.null.url;
        this.searchPoiB.reset();
        this.searchPlaceB.reset();
      } else if (event === 'A') {
        this.pointA = null;
        this.icon_pointA = icon.POINT_A_END.null.url;
        this.searchPoiA.reset();
        this.searchPlaceA.reset();
      }
      this.map.removeMarkersByTypes(this.typesMarkersPoints[event]);
    }
    this.showResultBtn = false;
    this.modalEnd = null;
    this.wait = false;
    this.map.removeLines('P2P');
  }

  public reset() {
    this.pointB = null;
    this.pointA = null;
    this.searchPoiB.reset();
    this.searchPoiA.reset();
    this.searchPlaceB.reset();
    this.searchPlaceA.reset();
    this.requestOfControl.setValue('');
    this.showResultBtn = false;
    this.project = null;
    this.icon_pointB = icon.POINT_B_END.null.url;
    this.icon_pointA = icon.POINT_A_END.null.url;
    this.map.removeMarkersByTypes(this.typesMarkersPoints.ALL);
    this.map.removeLines('P2P');
    this.salesforceSent = false;
    this.wait = false;
    this.waitFeasibility = false;
    this.typeSearchPlace.pointA = null;
    this.typeSearchPlace.pointB = null;
  }

  get title(): string {
    return this.p2pResult ? this.mapService.instant('POINT_TO_POINT.RESULT') : this.mapService.instant('POINT_TO_POINT.TITLE');
  }

  // Results

  public check(access_type) {
    this.wait = true;
    this.waitFeasibility = true;
    this.showResultBtn = true;
    this.p2pResult = null;

    forkJoin({
      point1: this.mapService.markerToRequest(this.pointB),
      point2: this.mapService.markerToRequest(this.pointA)
    }).subscribe(marker => {

      marker.point1['research_method'] = this.setResearchMathod(this.typeSearchPlace.pointB, marker.point1.type);
      marker.point2['research_method'] = this.setResearchMathod(this.typeSearchPlace.pointA, marker.point2.type);

      let point1 = this.mapService.markerToPointRequest(marker.point1);
      let point2 = this.mapService.markerToPointRequest(marker.point2);
      let req = this.mapService.createRequestBody([point1, point2], access_type , this.project , this.requestOfControl.value);

      // console.log(req);
      this.sendRequest(req);
    });
  }

  private setResearchMathod(point: string, type: string): string {
    const data = point ? point : type;
    let research_method: string = '';
    switch (data.toLocaleLowerCase()) {
      case 'poi': case 'point': case 'address':
        research_method = 'Address';
        break;
      case 'coordinates':
        research_method = 'Coordinates';
        break;
      default:
        research_method = 'Building';
        break;
    }
    return research_method;
  }

  private sendRequest(req) {
    this.mapService.createP2pQuotation(req).subscribe(res => {
      this.p2pResult = res;
      this.mapService.open('resultModal');
      this.wait = false;
      this.waitFeasibility = false;
      if (environment.show_line_network_p2p) {
        this.lightPath(res);
      }
    },
      err => {
        this.wait = false;
        this.waitFeasibility = false;
        switch (err.status) {
          case 500: this.errorTitle = this.mapService.instant('ERROR.500_1') + '<br />' + this.mapService.instant('ERROR.500_2') + '<br />' + this.mapService.instant('ERROR.500_3'); break;
          default: this.errorTitle = this.mapService.instant('ERROR.406_1') + '<br />' + this.mapService.instant('ERROR.406_2') + '<br />' + this.mapService.instant('ERROR.406_3'); break;
        }
        this.mapService.open('errorModal');
      });
  }

  get isOpenFiberUser() {
    if (environment.show_massive_company_project) {
      return true;
    } else if (this.mapService.userData && this.mapService.userData.company) {
      return this.mapService.userData.company.toLowerCase().replace(/\s/g, '') === 'openfiber';
    } else {
      return false;
    }
  }

  get isFastwebUser() {
    if (environment.show_massive_company_project) {
      return true;
    } else if (this.mapService.userData && this.mapService.userData.company) {
      return this.mapService.userData.company.toLowerCase() === 'fastweb' || this.mapService.userData.company.toLowerCase().includes('fastweb s.p.a.');
    } else {
      return false;
    }
  }

  public downloadTemplate(): void {
    let urlXslx: string;
    if (this.mapService.isOpenFiberUser || this.mapService.isWindTreUser) {
      urlXslx = '/api2/marketing/data/massive/import.xlsx';
    } else if (this.mapService.isFastwebUser) {
      urlXslx = '/api2/marketing/data/massive/import_fastweb.xlsx';
    } else {
      urlXslx = '/api2/marketing/data/massive/import.xlsx';
    }
    this.mapService.getExcelTemplate(urlXslx).subscribe(res => {
      const newBlob = new Blob([res], { type: 'text/csv' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = 'import_template.xlsx';
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
  }

  // Lines after quotation

  private lightPath(quotation) {
    this.ringLines = [];
    const coordinates_1 = quotation.p1_coordinate.coordinates;
    const coordinates_2 = quotation.p2_coordinate.coordinates;
    // save obj afference point
    const afferencePop_1 = quotation.p1_afference_pop ? this.popList.filter(e => e.nome === quotation.p1_afference_pop)[0] : null;
    const afferencePop_2 = quotation.p2_afference_pop ? this.popList.filter(e => e.nome === quotation.p2_afference_pop)[0] : null;

    // draw line from point to pop
    if (afferencePop_1) {
      const path1Coords = [
        { lat: coordinates_1[1], lng: coordinates_1[0] },
        { lat: Number(afferencePop_1.coordinates.coordinates[1]), lng: Number(afferencePop_1.coordinates.coordinates[0]) }
      ];
      const path1 = this.mapService.pathToPolyLineP2P(path1Coords, '#F33279', 1, 2);
      this.ringLines.push(path1);

      const line_path_inner_1 = this.mapService.pathToPolyLineP2P(path1Coords, '#FFFFFF', 1, 1);
      this.ringLines.push(line_path_inner_1);
    }

    if (afferencePop_2) {
      const path2Coords = [
        { lat: coordinates_2[1], lng: coordinates_2[0] },
        { lat: Number(afferencePop_2.coordinates.coordinates[1]), lng: Number(afferencePop_2.coordinates.coordinates[0]) }
      ];
      const path2 = this.mapService.pathToPolyLineP2P(path2Coords, '#F33279', 1, 2);
      this.ringLines.push(path2);

      const line_path_inner_2 = this.mapService.pathToPolyLineP2P(path2Coords, '#FFFFFF', 1, 1);
      this.ringLines.push(line_path_inner_2);
    }

    const ringsPoints_1 = null;
    const ringsPoints_2 = null;
    let ringPointsFromPop_1: any;
    let ringPointsFromPop_2: any;
    let nationalPopFromRing_1: any;
    let nationalPopFromRing_2: any;

    if (afferencePop_1 || afferencePop_2) {
      if ((afferencePop_1 && afferencePop_2) && (afferencePop_1.nome === afferencePop_2.nome)) {
        ringPointsFromPop_1 = this.takeRingPointsForPop(afferencePop_1, ringsPoints_1);
        ringPointsFromPop_2 = this.takeRingPointsForPop(afferencePop_1, ringsPoints_2);
      } else {
        // check if same ring
        let ring_1;
        let ring_2;
        if (afferencePop_1) {
          ringPointsFromPop_1 = this.takeRingPointsForPop(afferencePop_1, ringsPoints_1);
          if (ringPointsFromPop_1) {
            for (const r of ringPointsFromPop_1) {
              ring_1 = r[0];
            }
          }
        }
        if (afferencePop_2) {
          ringPointsFromPop_2 = this.takeRingPointsForPop(afferencePop_2, ringsPoints_2);
          if (ringPointsFromPop_2) {
            for (const r of ringPointsFromPop_2) {
              ring_2 = r[0];
            }
          }
        }
        if ((ring_1 && !ring_2) || (!ring_1 && ring_2)) {
          if (ring_1 && !ring_2 || (ring_1 === ring_2)) {
            this.lightRing(ringPointsFromPop_1);
          } else if (!ring_1 && ring_2) {
            this.lightRing(ringPointsFromPop_2);
          }
        } else if (ring_1 && ring_2) {
          this.lightRing(ringPointsFromPop_1);
          this.lightRing(ringPointsFromPop_2);
          const ring1 = ringPointsFromPop_1.keys();
          const ringVal1 = ring1.next().value;
          const ring2 = ringPointsFromPop_2.keys();
          const ringVal2 = ring2.next().value;
          nationalPopFromRing_1 = this.networkData.rings.filter(r => r.name === ringVal1);
          nationalPopFromRing_2 = this.networkData.rings.filter(r => r.name === ringVal2);
          if (nationalPopFromRing_1 && nationalPopFromRing_2) {
            this.lightPathNational(nationalPopFromRing_1, nationalPopFromRing_2);
          }
        }
      }
    }
    if (this.ringLines.length) {
      this.map.showLines(this.ringLines, 'P2P');
    }
  }

  private lightPathNational(pop1, pop2) {
    const arrToMatch = [pop1[0]['national-pop'], pop2[0]['national-pop']];
    let nationalPartialPath;
    if (pop1[0]['national-pop'] === pop2[0]['national-pop']) {
      nationalPartialPath = arrToMatch;
    } else {
      for (const popCouple of this.networkNationalData) {
        if (JSON.stringify(arrToMatch) === JSON.stringify(popCouple.pops)) {
          nationalPartialPath = popCouple.path;
        } else if (JSON.stringify(arrToMatch.reverse()) === JSON.stringify(popCouple.pops)) {
          nationalPartialPath = popCouple.path;
        }
      }
    }
    const popElements = [];
    for (const pop of nationalPartialPath) {
      const found = this.popList.filter(e => e.nome === pop)[0];
      popElements.push(found);
    }

    const popCoordinates = [];
    for (const pop of popElements) {
      const foundLat = pop.coordinates.coordinates[1];
      const foundLng = pop.coordinates.coordinates[0];
      popCoordinates.push({ lat: foundLat, lng: foundLng });
    }
    const path = this.mapService.pathToPolyLineP2P(popCoordinates, '#F33279', 1, 7);
    this.ringLines.push(path);
    const line_path_inner = this.mapService.pathToPolyLineP2P(popCoordinates, '#FFFFFF', 0.8, 3);
    this.ringLines.push(line_path_inner);

  }

  private lightRing(rings) {
    const coordinatesArray = [];

    const popsListMap = new Map();
    for (const e of this.popList) {
      popsListMap.set(e.nome, e);
    }

    rings.forEach(function (value) {
      for (const v of value) {
        const pop1 = { lat: popsListMap.get(v.pops[0]).lat, lng: popsListMap.get(v.pops[0]).lng };
        const pop2 = { lat: popsListMap.get(v.pops[1]).lat, lng: popsListMap.get(v.pops[1]).lng };
        coordinatesArray.push([pop1, pop2]);
      }
    }, rings);

    for (const segment of coordinatesArray) {
      const path = this.mapService.pathToPolyLineP2P(segment, this.networkData.provincial_color, 1, 2);
      this.ringLines.push(path);
    }
  }

  private takeRingPointsForPop(point, ring) {
    const objRingNames = [];
    for (const p of this.networkData.provincial) {
      if (p.pops.includes(point.nome)) {
        objRingNames.push(p.ring);
      }
    }
    const objRing = [];
    for (const p of this.networkData.provincial) {
      for (const o of objRingNames) {
        if (o === p.ring) {
          objRing.push(p);
        }
      }
    }
    ring = this.groupBy(objRing, res => res.ring);
    if (ring) {
      return ring;
    }
  }

  private groupBy(list, keyGetter) {
    const mapTmp = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = mapTmp.get(key);
      if (!collection) {
        mapTmp.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return mapTmp;
  }

  public sendToSalesforce(id) {
    this.waitSalesforce = true;
    this.baseService.sendToSalesforce(id).subscribe(res => {
      if (res) {
        let successMsg: SafeHtml =
          `<div class="d-flex flex-column">The feasibility details have been sent to your company\'s sales portal accounts.`;
        if (this.mapService && this.mapService.userData && this.mapService.userData.type && this.mapService.userData.type !== 'Pre-sales') {
          successMsg += `<a href=\"${res.url}" target=\"_blank\" class=\"toastr-link\">Go to my sales portal personal area.</a></div>`;
        }
        this.baseService.showSuccess(successMsg, this.salesforceToastrOptions);
        this.salesforcePersonalPage = res.url;
        this.salesforceSent = true;
        this.showSalesforceConfirmation = true;
        this.waitSalesforce = false;
      } else {
        this.baseService.showErrorMsg(res.error.message);
        this.baseService.toastr.error(res.error.message)
        this.waitSalesforce = false;
      }
    })
  }
}
